module.exports = __webpack_public_path__ + "img/scene2-19.277af169.jpg";